import {
  IconSystemBasket,
  IconSystemPlus,
  IconSystemTick,
} from '@moonpig/launchpad-assets'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { LoadingIndicator } from '@moonpig/web-shared-components'

export const StyledGiftLink = styled.a`
  position: absolute;
  inset: 0;
  z-index: 1;
`

export const StyledGiftButton = styled.button`
  background: transparent;
  border: 0;
  cursor: pointer;
  display: block;
  padding: 0;
  position: relative;
  text-align: left;
  width: fit-content;
  z-index: 0;
`

export const StyledGiftTileContainer = styled.div`
  position: relative;
  width: 148px;
  min-width: 148px;
  z-index: 0;
`

export const StyledGiftPlaceholder = styled.div`
  ${s({
    alignItems: 'flex-start',
    bgcolor: 'colorBackground01',
    border: 1,
    borderColor: 'colorBorder03',
    borderRadius: 'borderRadius03',
    boxShadow: 'boxShadow02',
    display: 'flex',
    flexDirection: 'column',
    p: 3,
  })}

  width: 100%;
  height: 232px;
  position: relative;
  overflow: hidden;
`

export const StyledGiftImage = styled.img`
  ${s({
    border: 1,
    borderColor: 'colorBorder03',
    borderRadius: 'borderRadius03',
  })}

  display: block;
  width: 140px;
  height: 140px;
  object-fit: cover;
  overflow: hidden;
`

export const StyledGiftImageWrapper = styled.div`
  position: relative;
`

export const StyledGiftImageFallback = styled.div`
  ${s({
    alignItems: 'center',
    border: 1,
    borderColor: 'colorBorder03',
    borderRadius: 'borderRadius03',
    color: 'colorTextBody',
    display: 'flex',
    justifyContent: 'center',
    px: 2,
    typography: 'typeBodyCaption',
  })}

  width: 140px;
  height: 140px;
  text-align: center;
`

export const StyledGiftBasketBadge = styled.div`
  ${s({
    alignItems: 'center',
    bgcolor: 'colorBackground01',
    borderRadius: 'borderRadiusCircle',
    boxShadow: 'boxShadow02',
    color: 'colorInteractionButton',
    display: 'flex',
    justifyContent: 'center',
  })}

  width: 40px;
  height: 40px;
  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 2;
`

export const StyledGiftBasketIcon = styled(IconSystemBasket)`
  ${s({
    height: 'iconMedium',
    width: 'iconMedium',
  })}

  display: block;
  color: currentcolor;
`

export const StyledGiftPlusBadge = styled.div`
  ${s({
    alignItems: 'center',
    bgcolor: 'colorBackground01',
    borderRadius: 'borderRadiusCircle',
    color: 'colorInteractionButton',
    display: 'flex',
    justifyContent: 'center',
  })}

  width: 18px;
  height: 18px;
  position: absolute;
  bottom: 4px;
  right: 4px;
`

export const StyledGiftPlusIcon = styled(IconSystemPlus)`
  width: 12px;
  height: 12px;
  display: block;
  color: currentcolor;
`

export const StyledGiftTickIcon = styled(IconSystemTick)`
  ${s({
    height: 'iconMedium',
    width: 'iconMedium',
  })}

  display: block;
  color: currentcolor;
`

export const StyledGiftBasketButton = styled.button`
  ${s({
    alignItems: 'center',
    bgcolor: 'colorBackground01',
    borderRadius: 'borderRadiusCircle',
    boxShadow: 'boxShadow02',
    color: 'colorInteractionButton',
    display: 'flex',
    justifyContent: 'center',
  })}

  width: 40px;
  height: 40px;
  position: absolute;
  right: 8px;
  bottom: 8px;
  z-index: 2;
  border: 0;
  padding: 0;
  cursor: pointer;

  &:disabled {
    cursor: wait;
  }
`
export const StyledGiftBasketSpinner = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: currentcolor;

  > div {
    ${s({
      height: 'iconMedium',
      width: 'iconMedium',
    })}
  }

  svg {
    color: currentcolor;
  }

  svg * {
    stroke: currentcolor;
  }
`

export const StyledGiftBasketLoadingIndicator = styled(LoadingIndicator)``

export const StyledGiftTextSection = styled.div`
  ${s({
    p: 3,
  })}

  width: 100%;
  min-width: 0;
`

export const StyledGiftTitle = styled.div`
  ${s({
    color: 'colorTextHeadline',
    typography: 'typeBodyCaption',
  })}

  font-family: Moonpig, Arial, sans-serif;
    font-weight: 300;
    line-height: 1.375rem;
    font-size: 0.875rem;
    
  line-clamp: 2;
  /* Matches the supplied concierge tile design more closely than the existing typography tokens. */

  width: 100%;
  height: 44px;
  overflow: hidden;
  word-break: break-word;
  text-overflow: ellipsis;

`

export const StyledGiftPrice = styled.div`
  ${s({
    color: 'colorTextHeadline',
    typography: 'typeBodyLabel',
    pb: 2,
  })}

  width: 100%;
  min-width: 0;
  height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
